/**
 * guest-only 页面(登录/注册/密码)的守卫,对应旧站 RedirectIfAuthenticated
 * 中间件:已登录用户访问这些页时送回其默认着陆页。静态应用没有服务端
 * 重定向,挂载后用 me() 判定并整页跳转(replace,不留历史记录)。
 */
import { useEffect } from 'react';
import { authClient } from './clients';
import { guestRedirectTarget } from './navigation';

export function useGuestOnly(): void {
  useEffect(() => {
    let cancelled = false;
    authClient
      .me()
      .then((me) => {
        if (!cancelled && me !== null) {
          window.location.replace(guestRedirectTarget(me));
        }
      })
      .catch(() => {
        // me() 失败(网络/后端异常)时不做跳转——访客仍可看到表单,
        // 提交时服务端守卫(403 forbidden)会兜底。
      });
    return () => {
      cancelled = true;
    };
  }, []);
}
